import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-add-square',
  imports: [],
  templateUrl: './icon-bold-add-square.html',
  standalone: true,
  styleUrl: './icon-bold-add-square.css'
})
export class IconBoldAddSquare {
  @Input() size: string = '24';
  @Input() color: string = 'currentColor';
}
